import React from 'react'
import FullName from '@cbgms/components/src/utils/FullName'
import { RecentlyOpenedWorkorderInvoice, ResultObjectType } from '@cbgms/api'
import { Grid, Typography } from '@mui/material'
import { splitRegistration } from '@cbgms/base/utils/vehicle'
import DescriptionIcon from '@mui/icons-material/Description'
import { formatDateTime } from '@cbgms/base/utils/datetime'
import Currency from '@cbgms/components/general/Currency'
import { ResultTitle } from '../../Results/Title'

interface RecentlyOpenedInvoiceProps {
  invoice: RecentlyOpenedWorkorderInvoice
  hasGroupHeader: boolean
}

export const RecentlyOpenedInvoice: React.FC<RecentlyOpenedInvoiceProps> = props => {
  const { invoice, hasGroupHeader } = props
  const workorderInvoiceRegistration = React.useMemo(() => splitRegistration(invoice.Registration), [invoice.Registration])

  return (
    <div>
      <Grid container spacing={2}>
        <ResultTitle resultType={ResultObjectType.Invoice} isTitleVisible={!hasGroupHeader} />
        <Grid item xs={2}>
          <DescriptionIcon fontSize='large' />
        </Grid>
        <Grid item xs={10}>
          <Typography variant='body1' component='h3' style={{ fontWeight: 'bold' }}>
            {invoice.InvoiceNumber} | {formatDateTime(invoice.InvoiceDate)} | <Currency amount={invoice.TotalVatIncluded} />
          </Typography>
          <Typography component='p'>
            {invoice.FirstName && <FullName firstName={invoice.FirstName || ''} lastName={invoice.Name || ''} />}
            {workorderInvoiceRegistration?.licensePlate}
            {invoice.Manufacturer && `${invoice.Manufacturer} ${invoice.Model} ${invoice.Type}`}
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}
